import { ColorPickerField } from '../components/ColorPickerField';
import slate from '../packages/plugins/content/slate';
const defaultSlate = slate();

const numberedSubSectionPlugin: any = {
  Renderer: ({ data, children }: any) => (
    <div
      className="numbered-sub-section flex"
      id={data?.linkId}
      style={{ margin: '10px 0' }}
    >
      <h3
        style={{
          width: 200,
          padding: 10,
          color: data?.titleColor ? data?.titleColor : 'rgba(44, 56, 126,1)',
        }}
        className="numbered-sub-section-title"
      >
        {data?.subSectionTitle ? data?.subSectionTitle : 'Subsection Title'}
        {/* <FaClipboardList
          size={22}
          color={'#777'}
          className="pointer section-link"
          style={{ marginLeft: 5 }}
          title="Copy Section Link"
          onClick={() => {
            if (data?.linkId) {
              let docStr = localStorage.getItem('AdminActiveDocument');
              let docSlug;
              if (docStr) {
                docSlug = JSON.parse(docStr).slug;
                const copyText = 'document:' + docSlug + '#' + data?.linkId;
                navigator.clipboard.writeText(copyText);
                alert('Copied section link!');
              }
            } else {
              alert('Please enter a link id');
            }
          }}
        /> */}
      </h3>
      <div
        style={{ padding: 0, flex: 1 }}
        className="numbered-sub-section-content"
      >
        {children}
      </div>
    </div>
  ),
  createInitialChildren: () => {
    return [
      [
        {
          plugin: defaultSlate,
          data: defaultSlate.createData(({ plugins }) => ({
            children: [
              {
                plugin: plugins.headings.h3,
                children: ['Enter subsection content...'],
              },
            ],
          })),
        },
      ],
    ];
  },

  id: 'numberedSubSectionPlugin',
  title: 'Numbered Sub Section',
  version: 1,
  controls: {
    type: 'autoform',
    schema: {
      properties: {
        subSectionTitle: { type: 'string', default: '' },
        titleColor: {
          type: 'string',
          default: 'rgba(44, 56, 126,1)',
          uniforms: {
            component: ColorPickerField,
            label: 'Title color:',
          },
        },
        linkId: { type: 'string', default: '' },
      },
    },
  },
};

export default numberedSubSectionPlugin;
